import { Post } from "../types/Post";
import { API_BASE_URL, testSessionId } from "./api";

export const sendPost = async (content: string): Promise<Post> => {
  const response = await fetch(`${API_BASE_URL}/posts`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${testSessionId}`,
    },
    body: JSON.stringify({ content: content }),
  });
  if (!response.ok) {
    throw new Error("Failed to send post");
  }
  const data = await response.json();
  return data;
};

export const addLove = async (postId: number): Promise<void> => {
  const response = await fetch(`${API_BASE_URL}/posts/${postId}/love`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${testSessionId}`,
    },
  });
  if (!response.ok) {
    throw new Error("Failed to add love");
  }
};

export const removeLove = async (postId: number): Promise<void> => {
  const response = await fetch(`${API_BASE_URL}/posts/${postId}/love`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${testSessionId}`,
    },
  });
  if (!response.ok) {
    throw new Error("Failed to remove love");
  }
};

export const replyPost = async (
  postId: number,
  content: string
): Promise<Post> => {
  const response = await fetch(`${API_BASE_URL}/posts/${postId}/reply`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${testSessionId}`,
    },
    body: JSON.stringify({ content: content }),
  });
  if (!response.ok) {
    throw new Error("Failed to reply to post");
  }
  const data = await response.json();
  return data;
};

export const getPost = async (postId: number): Promise<Post> => {
  const response = await fetch(`${API_BASE_URL}/posts/${postId}`);
  if (!response.ok) {
    throw new Error("Failed to get post");
  }
  const data = await response.json();
  return data;
};

export const getReplies = async (
  postId: number,
  limit: number = 40,
  offset: number = 0
): Promise<Post[]> => {
  const response = await fetch(
    `${API_BASE_URL}/posts/${postId}/replies?limit=${limit}&offset=${offset}`
  );
  if (!response.ok) {
    throw new Error("Failed to get replies");
  }
  const data = await response.json();
  return data;
};
